import { render, staticRenderFns } from "./object-array-service-config-field-value-item.component.vue?vue&type=template&id=7def8aeb&scoped=true"
import script from "./object-array-service-config-field-value-item.component.vue?vue&type=script&lang=ts"
export * from "./object-array-service-config-field-value-item.component.vue?vue&type=script&lang=ts"
import style0 from "./object-array-service-config-field-value-item.component.vue?vue&type=style&index=0&id=7def8aeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def8aeb",
  null
  
)

export default component.exports